export interface FeedbackOptionDTO {
  optionId: number;
  optionText: string;
  personIds: Array<number>;
  answers: number;
  percentage: number;
  [optionId: number]: number;
}
